const errorPrefix = 'address.validation.error.';

export const MISSING_UNIT_NUMBER = 'MISSING_UNIT_NUMBER';
// existing errors from server address validation
export const VALID_GEO_CODE = 'VALID_GEO_CODE';
export const OFAC_CODE = 'OFAC_CODE';
export const COUNTRY_CODE = 'COUNTRY_CODE';
export const T1_CONTENT_VALIDATION = 'T1_CONTENT_VALIDATION';
export const DUPLICATE_ADDRESS = 'DUPLICATE_ADDRESS';
export const STREET_DIGIT = 'STREET_DIGIT';
export const REVERSE_GEOCODE_COUNTRY = 'REVERSE_GEOCODE_COUNTRY';
export const POSTAL_CODE = 'POSTAL_CODE';
export const DEFAULT = 'DEFAULT';
// client side errors
export const NOT_EMPTY_VALIDATION = 'validation.error.notEmpty';
export const MAX_LENGTH_VALIDATION = 'validation.error.lengthAtMost';
export const MIN_LENGTH_VALIDATION = 'validation.error.lengthAtLeast';
export const POSTAL_CODE_VALIDATION = 'validation.error.postalCode';
export const CS_DEFAULT = 'CS_DEFAULT';
export const INVALID_UNIT_NUMBER = 'INVALID_UNIT_NUMBER';

// mapped error with their information
export const ERROR_INFORMATION = {
    [MISSING_UNIT_NUMBER]: {
        error_description: 'User needs to input unit number or is not an acceptable one',
        error_name: 'MISSiNG_UNIT_NUMBER',
        error_translation: 'Vrbo.lyp.manualLocation.validation.error.notEmpty.unit',
        error_translation_2: 'address.validation.error.invalid.unitNumber'
    },
    [VALID_GEO_CODE]: {
        error_translation: `${errorPrefix}valid.geoCoordinates`,
        error_description: 'Geoservice failed providng a correct lat lng for the location given',
        error_name: 'LAT_LONG_NULL'
    },
    [OFAC_CODE]: {
        error_translation: `${errorPrefix}ofac.filter`,
        error_description: 'Prohibited region to onboard property',
        error_name: 'PROHIBITED_REGION'
    },
    [COUNTRY_CODE]: {
        error_translation: `${errorPrefix}valid.countrycode`,
        error_description: 'Missing country code',
        error_name: 'MISSING_COUNTRY'
    },
    [T1_CONTENT_VALIDATION]: {
        error_translation: `${errorPrefix}valid.address.content`,
        error_description: 'Require them to enter street address, city and post code. This error occurs when any one of these is missing',
        error_name: 'MISSING_STREET_ADDRESS_CITY_PC'
    },
    [DUPLICATE_ADDRESS]: {
        error_translation: `${errorPrefix}duplicate.information`,
        error_description: 'Duplicate information in different fields',
        error_name: 'DUPLICATE_INFORMATION'
    },
    [STREET_DIGIT]: {
        error_translation: `${errorPrefix}streetdigit`,
        error_description: 'fails to include a numeric character in the street number input field',
        error_name: 'NO_STREET_NUMBER'
    },
    [REVERSE_GEOCODE_COUNTRY]: {
        error_translation: `${errorPrefix}reverse.postalCode.city`,
        error_description: 'Lat, long from pin placement on map does not match the country they provided',
        error_name: 'PIN_MAP_COUNTRY'
    },
    [POSTAL_CODE]: {
        error_translation: `${errorPrefix}reverse.postalCode.city`,
        error_description: 'User has located the pin in the map too far away',
        error_name: 'PIN_MAP'
    },
    [DEFAULT]: {
        error_translation: `${errorPrefix}default`,
        error_description: 'Geoservice failed providng a correct lat lng for the location given',
        error_name: 'LAT_LONG_NULL'
    },
    // client side errors only need description and name
    [NOT_EMPTY_VALIDATION]: {
        error_description: 'NOT_EMPTY_VALIDATION',
        error_name: 'NOT_EMPTY_VALIDATION'
    },
    [MAX_LENGTH_VALIDATION]: {
        error_description: 'MAX_LENGTH_VALIDATION',
        error_name: 'MAX_LENGTH_VALIDATION'
    },
    [MIN_LENGTH_VALIDATION]: {
        error_description: 'MIN_LENGTH_VALIDATION',
        error_name: 'MIN_LENGTH_VALIDATION'
    },
    [MIN_LENGTH_VALIDATION]: {
        error_description: 'MIN_LENGTH_VALIDATION',
        error_name: 'MIN_LENGTH_VALIDATION'
    },
    [POSTAL_CODE_VALIDATION]: {
        error_description: 'POSTAL_CODE_VALIDATION',
        error_name: 'POSTAL_CODE_VALIDATION'
    },
    [CS_DEFAULT]: {
        error_description: 'default',
        error_name: 'default'
    },
    [INVALID_UNIT_NUMBER]: {
        error_name: 'INVALID_UNIT_NUMBER',
        error_description: 'User has confirmed the unit number is valid'
    }
};

export const getErrorInfoClient = (key) => {
    if (ERROR_INFORMATION[key]) return ERROR_INFORMATION[key];
    return ERROR_INFORMATION.CS_DEFAULT;
};


const getLatLongErrorKey = (errCode) => {
    switch (errCode) {
    case 'Valid Geo Coordinates':
        return {
            location: 'generalState',
            code: VALID_GEO_CODE
        };
    case 'OFAC Filter':
        return {
            location: 'generalState',
            code: OFAC_CODE
        };
    case 'Valid Country Code':
        return {
            location: 'country',
            code: COUNTRY_CODE
        };
    case 'Tier One Address Content Validation':
        return {
            location: 'address1',
            code: T1_CONTENT_VALIDATION
        };
    case 'Duplicate Address Content':
        return {
            location: 'generalState',
            code: DUPLICATE_ADDRESS
        };
    case 'Street Digit':
        return {
            location: 'address1',
            code: STREET_DIGIT
        };
    case 'Reverse Geocode Country':
        return {
            location: 'pinMap',
            code: REVERSE_GEOCODE_COUNTRY
        };
    case 'Reverse Geocode Postal Code':
    case 'Reverse Geocode City':
    case 'Secondary Reverse Geocode Postal Code':
    case 'Secondary Reverse Geocode City':
        return {
            location: 'pinMap',
            code: POSTAL_CODE
        };
    default:
        return {
            location: 'generalState',
            code: DEFAULT
        };
    }
};

export default getLatLongErrorKey;
